import fi from './images/favicon.ico';
import fiAt from './images/apple-touch-icon.png';
import fi16 from './images/favicon-16x16.png';
import fi32 from './images/favicon-32x32.png';
import logo from './images/logo.svg';
import asideCenterLogo from './images/asideCenterLogo.svg';
import bg from './images/bg.svg';

const brooksKeretLabelOptions = {
  name: 'Brooks Keret',
  altName: 'Brooks Keret',
  site: 'https://www.dokka.com/',
  supportEmail: 'support@dokka.com',
  termsAndConditionLink: 'https://www.dokka.com/terms-conditions/',
  privacyLink: 'https://www.dokka.com/privacy-policy/',
  fi,
  fiAt,
  fi16,
  fi32,
  title: 'Brooks Keret',
  // TODO: confirm SSO (deferred). Defaulting to password login only.
  isSsoLogin: false,
  theme: 'brooksKeret',
  // Header/form logo is the DOKKA logo per the design (shown via FormHeader
  // when isWL is true). alt reflects the actual rendered asset.
  logo: {
    src: logo,
    alt: 'Dokka logo',
  },
  // Single Group 35 image (logo + slogan + DOKKA baked in, transparent).
  asideCenterLogo: {
    src: asideCenterLogo,
    alt: 'Brooks Keret',
    style: {},
    slogan: '',
  },
  // DOKKA mark is baked into asideCenterLogo, so no separate "Powered by" link.
  asidePoweredBy: false,
  // Brand colors taken from Figma:
  // - primary  #4B929F : "Sign in" contained button + aside gradient start
  // - secondary #002B55 : aside gradient end / logo mark (mobile aside gradient end)
  brand: {
    primary: {
      10: '#4B929F0A',
      20: '#4B929F33',
      40: '#4B929F80',
      60: '#4B929FCC',
      80: '#4B929F',
      90: '#34666F',
      100: '#34666F',
    },
    secondary: {
      10: '#002B550A',
      20: '#002B5533',
      40: '#002B5580',
      60: '#002B55CC',
      80: '#002B55',
      90: '#001B37',
      100: '#001B37',
    },
  },
  styles: {
    aside: {
      backgroundColor: '#002B55',
      style: {
        backgroundImage: `url(${bg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      },
    },
  },
};

export default brooksKeretLabelOptions;
